import { Modal } from 'antd'
import { Plug } from 'lucide-react'
import { McpKeySettings } from './mcp-key-settings.tsx'

export function McpSettingsModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal
      open={open}
      destroyOnHidden
      title={
        <div className="flex items-center gap-3 pr-6">
          <span className="text-accent flex size-10 shrink-0 items-center justify-center rounded-xl bg-[var(--accent-soft)]">
            <Plug aria-hidden className="size-5" />
          </span>
          <div>
            <div className="text-content text-base font-semibold">MCP 设置</div>
            <p className="text-content-muted m-0 mt-0.5 text-xs font-normal">将 Super Mega 连接到你的 AI 客户端</p>
          </div>
        </div>
      }
      onCancel={onClose}
      footer={null}
      width="44rem"
      mask={{ closable: false }}
    >
      <McpKeySettings />
    </Modal>
  )
}
